import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'

const wmIndexes = new WeakMap()

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    element
  ) => {
    const { ownerDocument } = element
    const opener = one(`.${utilities.modifiers.lightbox.dropdown}.${utilities.modifiers.lightbox.open}`, ownerDocument)
    const template = one('template', opener)
    const dropdownList = closest(`.${elements.dropdown_list}`, element)
    const itemCurrent = closest(`.${elements.dropdown_item}`, element)
    const items = all(`.${elements.dropdown_item}`, dropdownList)

    resetSelected(dropdownList)

    setSelected(element)

    wmIndexes.set(template, items.indexOf(itemCurrent))
  }
})

export const resetSelected = (dropdownList) => {
  const radioCurrent = one(`[type="radio"]:checked`, dropdownList)
  const anchorCurrent = one(`.${elements.anchor}[aria-current="true"]`, dropdownList)

  if (radioCurrent) {
    radioCurrent.checked = false
  }

  if (anchorCurrent) {
    anchorCurrent.removeAttribute('aria-current')
  }
}

export const setSelected = (element) => {
  if (element.classList.contains(elements.anchor)) {
    element.setAttribute('aria-current', 'true')
  }

  if (element.classList.contains(elements.dropdown_item_label)) {
    const radio = one(`[type="radio"]`, element)
    radio.checked = true
  }
}

export const getCurrent = (template) => {
  return wmIndexes.get(template)
}

export default element => {
  onClick.listen(element)
}
